import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { TrTableComponent } from '../table/tr-table.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DeliveryOptionDao } from '../test/delivery-option.dao';
import { DeliveryOption } from '../test/DeliveryOption';
import { EditDeliveryOptionComponent } from './edit-delivery-option/edit-delivery-option.component';
import { DeliveryOptionService } from '../test/delivery-option.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'lsu-delivery-option',
  templateUrl: './delivery-option.component.html',
  styleUrls: ['./delivery-option.component.scss']
})
export class DeliveryOptionComponent implements OnInit {

  constructor(
    public firestore: AngularFirestore,
    public deliveryOptionService: DeliveryOptionService,
    public dialog: MatDialog,
    public router: Router,
  ) { }

  @ViewChild(TrTableComponent, { static: true })
  public table: TrTableComponent<any>
  public formGroup = new FormGroup({
    name: new FormControl("", [Validators.required]),
    price: new FormControl("", [Validators.required]),
    quantity: new FormControl("", [Validators.required]),
  })

  public subscription: Subscription
  public dao: DeliveryOptionDao
  public columns: string[] = [
    "name",
    "price",
    "quantity",
    "action"
  ]

  public async ngOnInit(): Promise<void> {
    this.dao = new DeliveryOptionDao(this.deliveryOptionService)
    await this.dao.initialize()
  }

  public onAddDeliveryOption(addDeliveryOptionDialog: TemplateRef<any>): void {
    this.dialog.open(addDeliveryOptionDialog)
  }

  public async addDeliveryOption(): Promise<void> {
    const deliveryOption = this.formGroup.value as DeliveryOption;
    this.table.addItem(deliveryOption, async c => {
      const ref = await this.deliveryOptionService.addDeliveryOption(c)
      return ref.id
    })
  }

  // public onDeliveryOptionAdd(addDeliveryOptionDialog: TemplateRef<any>): void {
  //   this.dialog.open(addDeliveryOptionDialog)
  // }

  // public async addDeliveryOption(): Promise<void> {
  //   this.dao.loading.next(true)

  //   let valuetest = this.formGroup.value;
  //   const deliveryOption = valuetest as DeliveryOption;
  //   await this.dao.addDeliveryOption(deliveryOption)
  //   this.dao.addItem(deliveryOption)
  //   this.dao.loading.next(false)
  // }

  // openDialog(data, event: MouseEvent): void {
  //   event.stopPropagation()
  //   const dialogRef = this.dialog.open(EditDeliveryOptionComponent, {
  //     width: '350px',
  //     data: data
  //   });
  // }

  // deleteDeliveryOption(optionId: string, event: MouseEvent): void {
  //   event.stopPropagation()
  //   if (optionId) {
  //     this.dao.deleteDeliveryOption(optionId)
  //   }
  // }



  async openDialog(data): Promise<void> {
    const dialogRef = this.dialog.open(EditDeliveryOptionComponent, {
      width: '350px',
      data: data
    });

    const deliveryOptionUpdated = await dialogRef.afterClosed().toPromise<DeliveryOption>()
    if (deliveryOptionUpdated) {
      await this.table.updateItem(deliveryOptionUpdated)
    }
  }

  async onDeleteDeliveryOption(deliveryOptionId: string): Promise<void> {
    if (deliveryOptionId) {
      const ref = this.dialog.open(ConfirmationDialogComponent, {
        data: { title: `Are you sure you want to delete `}
      })

      const shouldDelete = await ref.afterClosed().toPromise()
      if (shouldDelete) {
        this.deleteDeliveryOption(deliveryOptionId)
      }
    }
  }

  async deleteDeliveryOption(deliveryOptionId: string): Promise<void> {
    return this.table.deleteItem(deliveryOptionId, async () => {
      this.deliveryOptionService.deleteDeliveryOption(deliveryOptionId)
    })
  }
}